module.exports = __webpack_public_path__ + "img/4.3bd3deff.jpg";